'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherLoader, FeatherShield, FeatherZap } from '@subframe/core';
import { Button, LogoArbitralis } from '@/shared/components/ui';
import type { UseNotificacaoSelfReturn } from '../hooks';
import { AvisoFunil } from './AvisoFunil';
import { PlanoCard } from './PlanoCard';
interface InicioScreenProps {
  vm: UseNotificacaoSelfReturn;
}
export type PlanosSectionVm = Pick<UseNotificacaoSelfReturn, 'planos' | 'planoTier' | 'carregandoPlanos' | 'planosErro' | 'recarregarPlanos' | 'escolherPlano'>;
const DESTAQUES = [{
  icon: <FeatherZap className="text-brand-600" />,
  titulo: 'Comece em minutos',
  descricao: 'Sem burocracia, sem espera.'
}, {
  icon: <FeatherShield className="text-brand-600" />,
  titulo: 'Seus dados protegidos',
  descricao: 'Em conformidade com a LGPD.'
}];
export const InicioScreen = t0 => {
  const $ = _c(13);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LogoArbitralis className="[&_img]:h-6 [&_img]:w-auto" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="border-brand-200 bg-brand-50 flex w-fit items-center gap-2 rounded-full border border-solid px-3 py-1"><span className="bg-brand-600 h-2 w-2 rounded-full" /><span className="text-brand-700 text-xs font-semibold">Notificação Extrajudicial</span></span>;
    t3 = <h1 className="text-heading-dark text-3xl leading-tight font-semibold tracking-tight sm:text-4xl lg:text-[44px]">Deixe sua empresa pronta para notificar</h1>;
    t4 = <p className="text-base leading-relaxed text-neutral-700">Em poucos passos, sua empresa estará pronta para enviar notificações extrajudiciais com validade jurídica total.</p>;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherArrowRight />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== vm) {
    t6 = <div className="flex max-w-[560px] flex-1 flex-col justify-center gap-6">{t2}{t3}{t4}<Button className="mt-2 self-start [&>span:first-child]:text-base [&>span:first-child]:font-medium" size="large" iconRight={t5} onClick={() => vm.goTo("cadastro")}>Vamos começar</Button></div>;
    $[5] = vm;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-wrap gap-8 border-t border-solid border-neutral-100 pt-6">{DESTAQUES.map(_temp)}</div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <div className="flex flex-1 flex-col justify-between gap-10 px-6 py-10 sm:px-10 sm:py-14 lg:px-16">{t1}{t6}{t7}</div>;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="relative hidden overflow-hidden bg-[url('/images/3453d673-f3c6-4f7b-bba9-f5756406f3c7_3840w.webp')] bg-cover bg-center bg-no-repeat lg:block lg:min-h-screen lg:w-1/2" />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8) {
    t10 = <div className="flex min-h-screen w-full flex-col overflow-hidden bg-white lg:flex-row">{t8}{t9}</div>;
    $[11] = t8;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
};
export const PlanosSection = t0 => {
  const $ = _c(3);
  const {
    vm
  } = t0;
  if (vm.planos.length === 0 && !vm.carregandoPlanos && !vm.planosErro) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex max-w-[640px] flex-col items-center gap-2 text-center"><h2 className="text-heading-dark text-2xl font-semibold sm:text-[32px]">Escolha o plano da sua operação</h2><p className="text-label-muted text-base">Franquia mensal de envios com todos os canais incluídos. Troque de plano quando quiser.</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== vm) {
    t2 = <div className="flex w-full flex-col items-center gap-8 bg-white px-6 py-14 md:px-20">{t1}{vm.planosErro ? <div className="w-full max-w-[640px]"><AvisoFunil variante="erro"><span className="flex-1">{vm.planosErro}</span><button type="button" onClick={vm.recarregarPlanos} className="flex-none text-sm font-semibold underline">Tentar novamente</button></AvisoFunil></div> : vm.planos.length === 0 ? <div className="text-label-muted flex items-center gap-2 text-sm"><FeatherLoader className="animate-spin" />Carregando planos...</div> : <div className="flex w-full max-w-[1120px] flex-wrap justify-center gap-5">{vm.planos.map(plano => <PlanoCard key={plano.tier} plano={plano} selecionado={plano.tier === vm.planoTier} ctaLabel={plano.ctaLabel} ctaVariant={plano.destaque ? "brand-primary" : "neutral-secondary"} onCta={() => vm.escolherPlano(plano.tier)} />)}</div>}</div>;
    $[1] = vm;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(destaque) {
  return <div key={destaque.titulo} className="flex max-w-[260px] items-center gap-3"><div className="bg-brand-50 flex h-10 w-10 flex-none items-center justify-center rounded-[12px]">{destaque.icon}</div><div><div className="text-heading-dark text-sm font-semibold">{destaque.titulo}</div><div className="text-xs text-neutral-500">{destaque.descricao}</div></div></div>;
}